/**
 * Adresse de l'explorateur Contenu › Programme ouvert sur un chapitre, un
 * onglet et, au besoin, un élément : les écrans qui en sortent (éditeurs
 * avancés, fiches de détail) y reviennent au lieu des anciennes listes.
 */
import type { OngletElements } from './types';

/** Chemin de l'explorateur du programme. */
export const CHEMIN_PROGRAMME = '/contenu/programme';

interface CibleExplorateur {
  chapitre?: string;
  onglet?: OngletElements;
  ouvert?: string;
}

/** Adresse de l'explorateur avec les seuls paramètres connus. */
export const adresseExplorateur = ({ chapitre, onglet, ouvert }: CibleExplorateur = {}): string => {
  const params = new URLSearchParams();
  if (chapitre) params.set('chapitre', chapitre);
  if (onglet && onglet !== 'lecons') params.set('onglet', onglet);
  if (ouvert) params.set('ouvert', ouvert);
  const requete = params.toString();
  return requete ? `${CHEMIN_PROGRAMME}?${requete}` : CHEMIN_PROGRAMME;
};
